<template>
  <div id="leftbar">
    <div v-if="windowWidth >= 768" width="240px" class="my-leftbar border-r">
      <UserMenu v-on="$listeners" />
    </div>
    <div v-else>
      <el-drawer
        :visible.sync="showLeftbarDrawer"
        :with-header="false"
        direction="ltr"
        :append-to-body="true"
        size="240px"
        :before-close="onBeforeClose"
      >
        <UserMenu />
      </el-drawer>
    </div>
  </div>
</template>

<script>
import UserMenu from './UserMenu.vue'

export default {
  name: 'LeftBar',
  components: {
    UserMenu
  },
  props: {},
  data() {
    return {
      windowWidth: window.innerWidth,
      drawer: true
    }
  },
  computed: {
    showLeftbarDrawer: {
      set(param) { // 先
        this.$store.dispatch('app/setShowLeftbarDrawer', param)
      }, get() { // 后
        console.log(this.$store.state.app.showLeftbarDrawer)
        return this.$store.state.app.showLeftbarDrawer
      }
    }
  },
  watch: {
  },
  created() {
    const that = this
    window.addEventListener('resize', that.onResize)
  },
  mounted() {
  },
  unmounted() {
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onBeforeClose() {
      this.showLeftbarDrawer = false
    },
    onResize() {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.my-leftbar {
  width: 240px;
  background-color: #fff;
  overflow-y: auto;
  position: fixed;
  top: 50px;
  bottom: 0;
  z-index: 800;
}
</style>
